module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-view right_auth"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('p', {
    staticClass: "money"
  }, [_vm._v("余额： "), _c('span', [_vm._v(_vm._s(_vm.remaindAmount))]), _vm._v("元")]), _vm._v(" "), _c('p', {
    staticClass: "remind"
  }, [_vm._v("为了保证您账户的安全，请不要轻易相信他人要您提供账号信息，如有疑问请联系客服")])]), _vm._v(" "), _c('div', {
    staticClass: "right btn"
  }, [_c('button', {
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'RechargeView'
        })
      }
    }
  }, [_vm._v("充值")])])]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('div', {
    staticClass: "form_modal left"
  }, [_c('i', {
    staticClass: "close"
  }), _vm._v(" "), _c('div', {
    staticClass: "form_ctr",
    class: {
      'invalid': !_vm.param.ordinaryName
    }
  }, [_c('label', {
    staticClass: "req"
  }, [_vm._v("姓名")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.param.ordinaryName),
      expression: "param.ordinaryName"
    }],
    staticClass: "short",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.param.ordinaryName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.param, "ordinaryName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "error"
  }, [_vm._v("请填写姓名")])]), _vm._v(" "), _c('div', {
    staticClass: "form_ctr",
    class: {
      'invalid': !_vm.param.userPetname
    }
  }, [_c('label', {
    staticClass: "req"
  }, [_vm._v("昵称")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.param.userPetname),
      expression: "param.userPetname"
    }],
    staticClass: "short",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.param.userPetname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.param, "userPetname", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "error"
  }, [_vm._v("请填写昵称")])]), _vm._v(" "), _c('div', {
    staticClass: "form_ctr",
    class: {
      'invalid': !_vm.param.ordinarySex
    }
  }, [_c('label', {
    staticClass: "req"
  }, [_vm._v("性别")]), _vm._v(" "), _vm._l(([{
    id: 1,
    label: '男'
  }, {
    id: 2,
    label: '女'
  }, {
    id: 3,
    label: '保密'
  }]), function(item) {
    return _c('label', {
      staticClass: "radio"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.param.ordinarySex),
        expression: "param.ordinarySex"
      }],
      attrs: {
        "type": "radio",
        "name": "sex"
      },
      domProps: {
        "value": item.id,
        "checked": _vm._q(_vm.param.ordinarySex, item.id)
      },
      on: {
        "change": function($event) {
          return _vm.$set(_vm.param, "ordinarySex", item.id)
        }
      }
    }), _vm._v(" " + _vm._s(item.label) + "\n                ")])
  }), _vm._v(" "), _c('p', {
    staticClass: "error"
  }, [_vm._v("请选择性别")])], 2), _vm._v(" "), _c('div', {
    staticClass: "form_ctr"
  }, [_c('label', {}, [_vm._v("兴趣爱好")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.param.tag),
      expression: "param.tag"
    }],
    staticClass: "long",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.param.tag)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.param, "tag", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "error"
  })]), _vm._v(" "), _c('div', {
    staticClass: "form_ctr"
  }, [_c('label', {}, [_vm._v("地址")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.param.ordinaryAddress),
      expression: "param.ordinaryAddress"
    }],
    staticClass: "long",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.param.ordinaryAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.param, "ordinaryAddress", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "error"
  })]), _vm._v(" "), _c('div', {
    staticClass: "form_ctr"
  }, [_c('label', {}, [_vm._v("备用联系人")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.param.backupName),
      expression: "param.backupName"
    }],
    staticClass: "long",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.param.backupName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.param, "backupName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "error"
  })]), _vm._v(" "), _c('div', {
    staticClass: "form_ctr"
  }, [_c('label', {}, [_vm._v("公司名称")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.param.companyName),
      expression: "param.companyName"
    }],
    staticClass: "long",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.param.companyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.param, "companyName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "error"
  })]), _vm._v(" "), _c('div', {
    staticClass: "form_ctr"
  }, [_c('label', {
    staticClass: "req"
  }, [_vm._v("余额短信提示")]), _vm._v(" "), _vm._l(([{
    id: 1,
    label: '开启'
  }, {
    id: 2,
    label: '关闭'
  }]), function(item) {
    return _c('label', {
      staticClass: "radio"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.param.isSendSMS),
        expression: "param.isSendSMS"
      }],
      attrs: {
        "type": "radio",
        "name": "message"
      },
      domProps: {
        "value": item.id,
        "checked": _vm._q(_vm.param.isSendSMS, item.id)
      },
      on: {
        "change": function($event) {
          return _vm.$set(_vm.param, "isSendSMS", item.id)
        }
      }
    }), _vm._v(_vm._s(item.label) + "\n                ")])
  }), _vm._v(" "), _c('p', {
    staticClass: "error"
  })], 2), _vm._v(" "), _c('ul', {
    staticClass: "btn",
    staticStyle: {
      "margin-top": "50px"
    }
  }, [_c('li', {
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.setParam()
      }
    }
  }, [_vm._v("重置")])])]), _vm._v(" "), _c('div', {
    staticClass: "avatar"
  }, [_c('p', {
    staticClass: "left",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("头像")]), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [(_vm.userHead) ? _c('img', {
    attrs: {
      "src": _vm.userHead,
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.doUpload
    }
  }, [_vm._v("上传头像")])])]), _vm._v(" "), _c('sd-upload', {
    ref: "upload",
    on: {
      "on-upload": _vm.onUpload
    }
  }), _vm._v(" "), _c('sd-modal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.recommendSum.sum),
      expression: "recommendSum.sum"
    }]
  }, [_c('div', {
    staticClass: "sum_wrap"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("返利总额: "), _c('span', [_vm._v(_vm._s(_vm.recommendSum.valueOne))]), _vm._v(" 元")]), _vm._v(" "), _c('i', {
    staticClass: "close",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.recommendSum.sum = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('ul', [_c('li', [_vm._v("未处理的钱："), _c('span', [_vm._v(_vm._s(_vm.recommendSum.valueTwo))]), _vm._v("元")]), _vm._v(" "), _c('li', [_vm._v("已处理的钱："), _c('span', [_vm._v(_vm._s(_vm.recommendSum.valueThree))]), _vm._v("元")]), _vm._v(" "), _c('li', [_vm._v("已推荐：" + _vm._s(_vm.recommendSum.valueFour + _vm.recommendSum.valueFive) + "人")])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6eb5a3aa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/InfoView.vue
// module id = 866
// module chunks = 1